module.exports = __webpack_public_path__ + "static/media/it.612e617f.svg";